export default __webpack_public_path__ + "static/media/angela-horoskop.4b56953a.jpeg";